import spacerStyles from './Space.module.css';

export default function HSpace({ size }: { size: 1 | 2 | 3 | 4 | 5 | 6 }) {
  return (
    <div
      className={[spacerStyles.space, spacerStyles[`hspace-${size}`]].join(' ')}
    />
  );
}
